import { render, staticRenderFns } from "./webinars.vue?vue&type=template&id=bbf57c4c&"
import script from "./webinars.vue?vue&type=script&lang=js&"
export * from "./webinars.vue?vue&type=script&lang=js&"
import style0 from "./webinars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports